import { render } from "./VideoTile.vue?vue&type=template&id=5c4bb901&scoped=true"
import script from "./VideoTile.vue?vue&type=script&lang=js"
export * from "./VideoTile.vue?vue&type=script&lang=js"

import "./VideoTile.vue?vue&type=style&index=0&id=5c4bb901&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c4bb901"]])

export default __exports__